function applyMeta(routes) {
  return routes.map((route) => ({
    ...route,
    meta: {
      ...(route.meta || {}),
      category: 'homeImprovement',
    },
  }));
}

export default applyMeta([
  {
    path: '/bathroom',
    name: 'Bathroom',
    component: () => import('../../components/BathroomProject.vue'),
  },
  {
    path: '/BathroomLandingPage',
    name: 'BathroomLandingPage',
    component: () => import('../../components/BathroomLandingPage.vue'),
  },
  {
    path: '/Bathpros',
    name: 'Bathpros',
    component: () => import('../../components/Bathpros.vue'),
  },
  {
    path: '/Gutter',
    name: 'Gutter',
    component: () => import('../../components/sewer.vue'),
  },
  {
    path: '/HVAC',
    name: 'HVAC',
    component: () => import('../../components/HVAC.vue'),
  },
  {
    path: '/Homefix',
    name: 'Homefix',
    component: () => import('../../components/Homefix.vue'),
  },
  {
    path: '/kitchen',
    name: 'Kitchen',
    component: () => import('../../components/KitchenProject.vue'),
  },
  {
    path: '/NaturaLawn',
    name: 'NaturaLawn',
    component: () => import('../../components/NaturaLawn.vue'),
  },
  {
    path: '/Policyproviders',
    name: 'Policyproviders',
    component: () => import('../../components/Policyproviders.vue'),
  },
  {
    path: '/SolarQuotePage',
    name: 'SolarQuotePage',
    component: () => import('../../components/SolarQuotePage.vue'),
  },
  {
    path: '/Unemployment',
    name: 'Unemployment',
    component: () => import('../../components/Unemployment.vue'),
  },
  {
    path: '/Unemployment_cf',
    name: 'Unemployment_cf',
    component: () => import('../../components/Unemployment_cf.vue'),
  },
  {
    path: '/VisitorsCov',
    name: 'VisitorsCov',
    component: () => import('../../components/VisitorsCov.vue'),
  },
  {
    path: '/Walkin',
    name: 'Walkin',
    component: () => import('../../components/Walkin.vue'),
  },
  {
    path: '/window',
    name: 'Window',
    component: () => import('../../components/WindowProject.vue'),
  },
  {
    path: '/Window1',
    name: 'Window1',
    component: () => import('../../components/Window1.vue'),
  },
  {
    path: '/Window2',
    name: 'Window2',
    component: () => import('../../components/Window2.vue'),
  },
  {
    path: '/Window3',
    name: 'Window3',
    component: () => import('../../components/Window3.vue'),
  },
  {
    path: '/Window4',
    name: 'Window4',
    component: () => import('../../components/Window4.vue'),
  },
  {
    path: '/Window5',
    name: 'Window5',
    component: () => import('../../components/Window5.vue'),
  },
  {
    path: '/YourHomes',
    name: 'YourHomes',
    component: () => import('../../components/YourHomes.vue'),
  },
  {
    path: '/Yourinsurance',
    name: 'Yourinsurance',
    component: () => import('../../components/Yourinsurance.vue'),
  },
  {
    path: '/avbathroom',
    name: 'avBathroom',
    component: () => import('../../components/avBathroom.vue'),
  },
  {
    path: '/insurance',
    name: 'insurance',
    component: () => import('../../components/insurance.vue'),
  },
  {
    path: '/petinsurance',
    name: 'petinsurance',
    component: () => import('../../components/petinsurance.vue'),
  },
  {
    path: '/property',
    name: 'property',
    component: () => import('../../components/property.vue'),
  },
  {
    path: '/roof',
    name: 'roof',
    component: () => import('../../components/Homeowners.vue'),
  },
  {
    path: '/solar',
    name: 'solar',
    component: () => import('../../components/solar.vue'),
  },
]);
